import { createModalHook } from '../../hooks'

export const usePulseBenefitModal = createModalHook()
